<template>
  <div v-if="detail" class="container">
    <h2>{{ detail.user_name }}</h2>
    <ul>
      <li>
        <label>手机号：</label>
        <p>{{ detail.phone }}</p>
      </li>
      <li>
        <label>身份证号：</label>
        <p>{{ detail.idcard }}</p>
      </li>
      <li>
        <label>银行卡号：</label>
        <p>{{ detail.bank_card_number }}</p>
      </li>
      <li style="width:100%">
        <label>openid：</label>
        <p>{{ detail.openid }}</p>
      </li>
      <li>
        <label>表格日期：</label>
        <p>{{ detail.salary_date }}</p>
      </li>
      <li>
        <label>上传时间：</label>
        <p>{{ detail.create_time }}</p>
      </li>
      <li>
        <label>修改时间：</label>
        <p>{{ detail.update_time }}</p>
      </li>
      <li>
        <label>上传批次号：</label>
        <p>{{ detail.no }}</p>
      </li>
      <li>
        <label>应发金额：</label>
        <p>{{ detail.pre_amount }}</p>
      </li>
      <li>
        <label>实发金额：</label>
        <p>{{ detail.real_amount }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: ""
    };
  },
  mounted() {
    if (this.detailVal != undefined) {
      this.getDetail();
    }
  },
  watch: {
    detailVal() {
      this.getDetail();
    }
  },
  props: {
    detailVal: {}
  },
  methods: {
    getDetail() {
      this.detail = this.detailVal;
      // console.log(this.detail);
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 50px 2%;
  h2 {
    font-size: 20px;
    margin: 20px 0;
  }
  > ul {
    li {
      display: inline-block;
      width: 30%;
      margin-bottom: 20px;
      label,
      p {
        display: inline-block;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
</style>
